import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-bottommenu-resto',
  templateUrl: './bottommenu-resto.component.html',
  styleUrls: ['./bottommenu-resto.component.scss']
})
export class BottommenuRestoComponent implements OnInit {
  UserCondition: boolean;

  constructor() { }

  ngOnInit(): void {
    this.UserCondition = sessionStorage.getItem('access_token') ? true : false;

  }

}
